/**
 * SFrame109 – Confirmation: "Thank you for taking that step."
 * Figma Frame 9 (node 1018:13692)
 *
 * Simple empathy screen after 3-step onboarding. Centered heading, Next button.
 */

import { useNavigate, useLocation } from 'react-router-dom';

interface LocationState {
  deceasedName?: string;
  estateId?: string;
}

export default function SFrame109() {
  const navigate = useNavigate();
  const location = useLocation();
  const { deceasedName, estateId } = (location.state as LocationState) || {};

  const handleNext = () => {
    navigate('/sframe-110', { state: { deceasedName, estateId } });
  };

  return (
    <div className="min-h-screen flex flex-col">
      {/* Top header bar */}
      <div className="bg-dark-gradient py-3 px-6">
        <p className="text-center text-white-alt font-semibold text-base tracking-wide">
          Estate Settlement
        </p>
      </div>

      {/* Cream to light-blue gradient background */}
      <div className="flex-1 flex flex-col items-center justify-center px-6 bg-gradient-to-b from-white to-blue-100">
        <h1 className="font-display text-2xl sm:text-3xl text-blue-900 text-center mb-8">
          Thank you for taking that step.
        </h1>

        <button
          onClick={handleNext}
          className="px-6 py-2.5 rounded-md font-medium text-sm bg-blue-600 text-white-alt hover:bg-blue-900 transition-all"
        >
          Next
        </button>
      </div>
    </div>
  );
}
